// extracted by mini-css-extract-plugin
export default {"container":"OurNews_container__urAg+","cardcontainer":"OurNews_cardcontainer__Nvap5","erroralert":"OurNews_erroralert__pPnhN"};